<ul class="media">
  <li *ngFor="let item of items; let imageNum = index" (click)="openLightbox(imageNum)">
    <image [src]="item.thumbnail"></image>
  </li>
</ul>

<lightbox (close)="closeLightbox()" [index]="index" [items]="items"></lightbox>
